<template>
  <v-card class='mx-auto' max-width='800' tile>
    <v-card-title class='text-center'>Reporte Manifiesto de Carga</v-card-title>
    <v-data-table v-model='selected' :headers='headers' :items='contenedores' :single-select='singleSelect' item-key='id' dense show-select class='elevation-1'>
      <template v-slot:item.cantidad='{ item }'>{{ Number(item.cantidad).toFixed(2) }}</template>
      <template v-slot:item.peso='{ item }'>{{ Number(item.peso).toFixed(2) }}</template>
      <template v-slot:item.tipo='{ item }'>
        <v-combobox v-model='item.tipo' :items='tiposItems'></v-combobox>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color='error' @click='cancelarReporte' text>Cancelar</v-btn>
      <v-btn color='success' @click='ejecutarReporte' text>Ejecutar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'ReporteManifiesto',
        data() {
            return {
                conenedores: [],
                singleSelect: false,
                tiposItems: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
                selected: [],
                headers: [
                    { text: 'Contenedores', value: 'contenedor' },
                    { text: 'Fecha', value: 'fecha' },
                    { text: 'MAWB', value: 'mawb' },
                    { text: 'cantidad', align: 'right', value: 'cantidad' },
                    { text: 'Peso', align: 'right', value: 'peso' },
                    { text: 'Tipo', value: 'tipo' },
                ],
            }
        },
        created() {
            this.refrescarContenedores();
        },
        methods: {
            refrescarContenedores() {
                const paramURL = (process.env.VUE_APP_BASE_URL_SERVER || "http://localhost:8951") + "/ims/reportes/manifiesto/lista"
                console.log('refrescarContenedores URL ', paramURL);
                axios.get(paramURL).then((result) => {
                    console.log('result :>> ', result);
                    this.contenedores = []
                    result.data.data.forEach((item) => {
                        this.contenedores.push({
                            id: item.id,
                            select: true,
                            fecha: item.fecha_str,
                            cantidad: item.cantidad_guias,
                            contenedor: item.numero_contenedor,
                            mawb: item.mawb,
                            peso: item.peso,
                            tipo: 'A'
                        })
                        this.selected.push(false)
                    })
                    console.log('this.contenedores :>> ', this.contenedores);
                }).catch((err) => {
                    alert('Error en Refrescar :', paramURL + JSON.stringify(err))
                });
            },
            cancelarReporte() {
                this.$router.push("/");
            },
            ejecutarReporte() {
                const paramURL = (process.env.VUE_APP_BASE_URL_SERVER || "http://localhost:8951") + "/ims/reportes/manifiesto/ejecutar"

                let listaContenedores = []
                for (let iIndex = 0; iIndex < this.selected.length; iIndex ++) {
                       listaContenedores.push( {
                            contenedor : this.selected[iIndex].contenedor,
                            tipo : this.selected[iIndex].tipo
                    } )
                }
                console.log('listaContenedores :>> ', listaContenedores);
                Promise.all([axios.post(paramURL, { contenedores : listaContenedores }).then((result) => {
                    const excelUrl = result.data.url;
                    console.log('excelUrl :>> ', excelUrl);
                    window.open("/" + excelUrl, "_blank");
                }).catch((err) => {
                    alert('Error de Generarndo Reporte ', JSON.stringify(err))
                })])

               //  this.$router.push("/");
            }
        },

    }
</script>

<style >